import { FC } from 'react'
import MediaCard from './common/MediaCard'

type Props = {}

const PostroomReinventedCard: FC<Props> = ({}) => {
  return (
    <MediaCard
      layout={{
        desktop: 'content-left-media-right',
        mobile: 'content-top-media-bottom',
      }}
      imageContainerWidth={'37%'}
      imageFitPreset='cover-left'
      image={{
        alt: 'Scattered envelopes design',
        desktop: {
          src: '/images/new/scattared-envelops-cropped.png',
          dimensions: { width: 590, height: 690 },
        },
        mobile: {
          src: '/images/new/scattared-envelops.png',
          dimensions: { width: 683, height: 1024 },
        },
      }}
    >
      <div className='d-flex flex-1 flex-column px-4 pt-8 pe-lg-0 ps-lg-20 pt-lg-9 pb-lg-14'>
        <h2 className='lh-105 fw-semibold mb-6 fs-fluid-40-80'>
          The Postroom, Reinvented
        </h2>
        <div className='d-flex flex-column lh-140 fs-fluid-18-24'>
          How do we process over a million pieces of mail with speed and
          precision? By combining enterprise-grade scanning with custom-built
          automation, we've transformed the way mail is handled—eliminating
          manual steps and ensuring accuracy at scale.
          <br />
          <br />
          Our intelligent system, powered by machine learning, doesn't just scan
          mail—it understands it. From sorting and categorising to fraud
          detection and compliance checks, every piece of mail is processed in
          real-time, seamlessly integrated with IBML Fusion scanners for a fully
          optimised workflow.
          <br />
          <br />
          By rethinking traditional mail processing, we've built an
          industry-leading system that delivers efficiency, security, and
          automation - helping businesses manage their post with zero friction.
        </div>
      </div>
    </MediaCard>
  )
}

export default PostroomReinventedCard
